import { TimeSeriesGranularity } from 'dashboards/types/time';

export const HEATMAP_CHART_GRANULARITIES: TimeSeriesGranularity[] = [
  'DAY',
  'HOUR',
];
